import React from 'react'

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton'
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector'
import LinkStyleButton from  '@/components/elements/global/buttons/LinkStyleButton'
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput'
import CheckboxPanel from  '@/components/elements/global/dropdown/CheckboxPanel'
import NotificationBar from  '@/components/elements/languages/NotificationBar'

//hooks
import UseAllUsersScreen, {allUsersScreenConstants} from './AllUsersScreen.hooks'

//styling
import "../../../../../css/orgSettings/users/users.scss"



const AllUsersScreen = () => {  

    const {
        filterButton,
        notificationDetails,
        paginationSettings,
        setSearchString,
        searchString,
        onAddUserClick,
        tableContent,
        showSimpleTable,
        userPublishingDownloadLink,
        onIncludeArchivedUserClick,
        includeArchivedUsers,
        showFilterPanel,
        setShowFilterPanel,
        getNewPage,
        isLoading
    } = UseAllUsersScreen();

    return(
        <div className="all-users-screen" data-testid="all-users-tab">
            <span className="headers" >
                <h1>{allUsersScreenConstants.header}</h1>
                <BasicButton
                    className="add-user-button"
                    content={allUsersScreenConstants.addNewUserButtonText}
                    ariaLabel={allUsersScreenConstants.addNewUserButtonLabel}
                    onButtonClick={onAddUserClick}
                />
            </span>

            <div className='user-top-button-panel'> 
                <LinkStyleButton content={filterButton} ariaLabel={allUsersScreenConstants.filterButtonLabel} onButtonClick={() => setShowFilterPanel(!showFilterPanel)}  />
                <SimpleSearchInput ariaLabel={allUsersScreenConstants.searchInputLabel} setSearchString={setSearchString} searchString={searchString} />
            </div>

            { showFilterPanel &&
                <CheckboxPanel
                    panelTitle={allUsersScreenConstants.panelTitle}
                    items={[{id: 1, content: allUsersScreenConstants.archivedUserLabel, isSelected: includeArchivedUsers, onCheck: onIncludeArchivedUserClick}]}
                />
            }

            { showSimpleTable &&
                <SimpleTable
                    isLoading={isLoading}
                    simpleTableContent={tableContent}
                    noDataMessage={allUsersScreenConstants.noDataMessage}
                    maxContentLength={20}
                    isInfiniteScroll={false}
                />
            }
            
            {paginationSettings?.hasPagination &&
                <SimplePageSelector
                    currentPage={paginationSettings.currentPage}
                    totalPages={paginationSettings.totalPages}
                    setPage={getNewPage}
                />
            }
            
            <div className='user-button-panel'>
                <BasicButton
                    content={allUsersScreenConstants.userListButtonText}
                    ariaLabel={allUsersScreenConstants.userListButtonLabel}
                    isLink
                    linkUrl={allUsersScreenConstants.userListDownloadLink}
                />

                <BasicButton
                    content={allUsersScreenConstants.activeReportButtonText}
                    ariaLabel={allUsersScreenConstants.activeReportButtonLabel}
                    isLink
                    linkUrl={allUsersScreenConstants.activeUserDownloadLink}
                />
                <BasicButton
                    content={allUsersScreenConstants.publishingButtonText}
                    ariaLabel={allUsersScreenConstants.publishingButtonLabel}
                    isLink
                    linkUrl={allUsersScreenConstants.userPublishingDownloadLink}
                />

                <BasicButton
                    content={allUsersScreenConstants.recognitionButtonText}
                    ariaLabel={allUsersScreenConstants.recognitionButtonLabel}
                    isLink
                    linkUrl={allUsersScreenConstants.userRecognitionDownloadLink}
                />
            </div>

            <NotificationBar
                show={notificationDetails.show}
                notificationStatus={notificationDetails.status}
                msg={notificationDetails.message}
            />
        </div>
    )
}

export default AllUsersScreen